<template>
  <div class="Home">
    <v-container class="pa-0">
      <div class="logo">
        <img
          src="@/assets/images/freed-logo.svg"
          class="img-fluid logo-size"
          alt="..."
        />
      </div>
    </v-container>
    <div class="heroSignupWrapper">
      <div class="heroSignupSection">
        <div class="heroBannerContainer">
          <img
            :src="heroBannerImage"
            alt="Hero Banner"
            class="heroBannerImage"
          />
          <div class="heroBannerOverlay">
            <div class="bannerTitle">FREED Partner Program</div>
            <div class="bannerSubTitle">Make Money Helping <br />People</div>
          </div>
        </div>
        <SignupForm :carousel="carousel" />
      </div>
    </div>
    <div class="setpSectionBG">
      <v-container>
        <div class="incomeSection">
          <div class="incomeHeading">
            Create a new Income Stream in 3 easy steps
          </div>
          <div class="incomeSubHeading font-weight-medium">
            Help Others. Make Money. It’s a win-win!
          </div>

          <div class="incomeCardContaner">
            <div class="row">
              <div class="col-md-4">
                <img :src="require('@/assets/images/home/image1.png')" />
                <div class="bodyContainer">
                  <div class="bdDiscretion">
                    <span class="bdHeading">Sign Up</span>
                    with<br />
                    Zero Investment
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <img :src="require('@/assets/images/home/image2.png')" />
                <div class="bodyContainer">
                  <div class="bdDiscretion">
                    <span class="bdHeading">Become a Partner</span>
                    & <br />Get Your Certificate
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <img :src="require('@/assets/images/home/image3.png')" />
                <div class="bodyContainer">
                  <div class="bdDiscretion">
                    Share Your Referral Link <br />
                    &
                    <span class="bdHeading"> Get Paid</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="incomeCardContaner">
            <div class="row">
              <div class="col-md-4">
                <div class="incomeCard">
                  <div class="incomeStep">STEP 1</div>
                  <div class="incomeCardInner">
                    <div class="bodyContainer">
                      <div class="bdDiscretion">
                        <div class="bdHeading">SIGN UP</div>
                        with<br />
                        Zero Investment
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="incomeCard primaryBorder">
                  <div class="incomeStep">STEP 2</div>
                  <div class="incomeCardInner primaryBorder">
                    <div class="bodyContainer">
                      <div class="bdDiscretion">
                        <div class="bdHeading">BECOME A PARTNER</div>
                        and get your<br />
                        Certificate
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="incomeCard">
                  <div class="incomeStep">STEP 3</div>
                  <div class="incomeCardInner">
                    <div class="bodyContainer">
                      <div class="bdDiscretion">
                        <div class="bdHeading">GET PAID</div>
                        to help people get<br />
                        Debt Free
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </v-container>
    </div>

    <div class="greyIncomeSection videoSectionBG">
      <div class="container">
        <div class="incomeHeading">
          Learn more about the FREED Partner Program
        </div>
        <div class="videoSection">
          <v-slide-group
            class="pa-1 video-carousel"
            selected-class="bg-success"
          >
            <v-slide-group-item key="1">
              <div class="col-md-4 col-xs-12 videoCard">
                <div class="videoThumbnail" @click="playVideo('rtkEnOXMerY')">
                  <img
                    src="@/assets/images/youTubeVideosBanner/introductionBanner.svg"
                    alt="Introduction"
                    class="videoBanner"
                  />
                  <div class="playButton">
                    <svg
                      width="68"
                      height="68"
                      viewBox="0 0 68 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="34" cy="34" r="34" fill="white" />
                      <path d="M26 20L48 34L26 48V20Z" fill="#02416e" />
                    </svg>
                  </div>
                </div>
                <div class="videoTitle">Introduction</div>
              </div>
            </v-slide-group-item>
            <v-slide-group-item key="2">
              <div class="col-md-4 col-xs-12 videoCard">
                <div class="videoThumbnail" @click="playVideo('DuTQ4BHgL-w')">
                  <img
                    src="@/assets/images/youTubeVideosBanner/howItWorksBanner.svg"
                    alt="How It Works"
                    class="videoBanner"
                  />
                  <div class="playButton">
                    <svg
                      width="68"
                      height="68"
                      viewBox="0 0 68 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="34" cy="34" r="34" fill="white" />
                      <path d="M26 20L48 34L26 48V20Z" fill="#02416e" />
                    </svg>
                  </div>
                </div>
                <div class="videoTitle">How It Works</div>
              </div>
            </v-slide-group-item>
            <v-slide-group-item key="3">
              <div class="col-md-4 col-xs-12 videoCard">
                <div class="videoThumbnail" @click="playVideo('MLWXvnU3Ns8')">
                  <img
                    src="@/assets/images/youTubeVideosBanner/becomeFreedPartner.svg"
                    alt="Become a FREED Partner"
                    class="videoBanner"
                  />
                  <div class="playButton">
                    <svg
                      width="68"
                      height="68"
                      viewBox="0 0 68 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="34" cy="34" r="34" fill="white" />
                      <path d="M26 20L48 34L26 48V20Z" fill="#02416e" />
                    </svg>
                  </div>
                </div>
                <div class="videoTitle">Become a FREED Partner</div>
              </div>
            </v-slide-group-item>
          </v-slide-group>
        </div>
      </div>
    </div>

    <div class="normalIncomeSection">
      <div class="container">
        <div class="incomeHeading">Why join the FREED Partner Program?</div>
        <div class="greyIncomeSectionSub">
          <div class="whyJoinContainer">
            <div class="row whyJoinGrid">
              <div class="col-md-6 col-sm-6">
                <div class="whyJoinCard">
                  <img
                    src="@/assets/images/whyToJoin/partnerOpportunity.svg"
                    alt="..."
                    class="whyJoinIcon"
                  />
                  <p class="whyJoinText">
                    An opportunity to make a difference & earn recognition
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-sm-6">
                <div class="whyJoinCard">
                  <img
                    src="@/assets/images/whyToJoin/cutDebt.svg"
                    alt="..."
                    class="whyJoinIcon"
                  />
                  <p class="whyJoinText">
                    Help India become Debt Free & Change Lives
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-sm-6">
                <div class="whyJoinCard">
                  <img
                    src="@/assets/images/whyToJoin/quickTransaction.svg"
                    alt="..."
                    class="whyJoinIcon"
                  />
                  <p class="whyJoinText">
                    Transparent and Quick Weekly Payouts
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-sm-6">
                <div class="whyJoinCard">
                  <img
                    src="@/assets/images/whyToJoin/partnerIncome.svg"
                    alt="..."
                    class="whyJoinIcon"
                  />
                  <p class="whyJoinText">
                    An Alternate Income Stream with Zero Investment
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 justify-center align-center pt-4 pb-0">
            <div class="leftIncomeList moreIncome_sec">
              <ul>
                <li>
                  <div class="lastCard">
                    <h3>For Questions - Call/WhatsApp us at +91-9971800833</h3>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="joinNowSection">
          <button
            type="button"
            class="btn btn-secondary calculator-btn"
            @click="scrollToTop"
          >
            Join Now
            <!-- <div class="icon-container">
              <img
                src="@/assets/images/paper-plane-white.svg"
                class="img-fluid w-100e"
                alt="..."
              />
            </div> -->
          </button>
        </div>
      </div>
    </div>

    <div class="greyIncomeSection" style="padding-bottom: 20px">
      <v-container>
        <div class="incomeHeading">We are committed to your success</div>
        <div class="incomeSubHeading">
          We'll help you make people happy while earning money
        </div>
        <div class="greyIncomeSectionSub" style="padding-bottom: 0px">
          <div class="row">
            <div class="col-md-6">
              <div class="leftIncomeList">
                <ul>
                  <li>
                    <div class="incomeContentCardSm">
                      <p class="INCHeading">
                        <img
                          src="@/assets/images/paper-plane-orange.svg"
                          alt="..."
                          class="orange-plane-icon"
                        />Dedicated Support Team
                      </p>
                      <p class="incSUbcontent">
                        We will make sure you have a smooth journey as our
                        support team answers all your questions.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div class="incomeContentCardSm">
                      <p class="INCHeading">
                        <img
                          src="@/assets/images/paper-plane-orange.svg"
                          alt="..."
                          class="orange-plane-icon"
                        />Sales Assistance
                      </p>
                      <p class="incSUbcontent">
                        FREED Debt expert will help you crack your first few
                        sales. You learn from the experts.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div class="incomeContentCardSm">
                      <p class="INCHeading">
                        <img
                          src="@/assets/images/paper-plane-orange.svg"
                          alt="..."
                          class="orange-plane-icon"
                        />Your Own Dashboard
                      </p>
                      <p class="incSUbcontent">
                        Everything you need in one place. You can access your
                        total earnings, success rate, number of debt-free lives
                        created - all at your fingertips.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div class="incomeContentCardSm">
                      <p class="INCHeading">
                        <img
                          src="@/assets/images/paper-plane-orange.svg"
                          alt="..."
                          class="orange-plane-icon"
                        />Exclusive Community Access
                      </p>
                      <p class="incSUbcontent">
                        Learn from other FREED partners & share your experience
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <div class="PPcontentImg">
                <img
                  src="@/assets/images/we_are_commited.png"
                  class=""
                  alt="..."
                />
              </div>
            </div>
          </div>
        </div>
      </v-container>
    </div>

    <div class="PPAboutSection">
      <div class="incomeHeading">About FREED</div>
      <div class="PPSubHeading ppBoldSub">
        FREED is India’s first debt relief company, helping people break free
        from debt
      </div>
      <v-container>
        <v-row>
          <v-col>
            <div class="iosCard">
              <img src="@/assets/images/badge1.png" alt="..." />
            </div>
          </v-col>
          <v-col>
            <div class="iosCard">
              <img src="@/assets/images/badge2.png" alt="..." />
            </div>
          </v-col>
          <v-col>
            <div class="iosCard">
              <img src="@/assets/images/badge3.png" alt="..." />
            </div>
          </v-col>
          <v-col>
            <div class="iosCard">
              <img src="@/assets/images/badge4.png" alt="..." />
            </div>
          </v-col>
          <v-col>
            <div class="iosCard">
              <img src="@/assets/images/badge5.png" alt="..." />
            </div>
          </v-col>
        </v-row>
        <div class="inPressSection">
          <div class="incomeHeading">Media Mentions</div>
          <v-slide-group class="pa-4" selected-class="bg-success" show-arrows>
            <v-slide-group-item v-for="n in 38" :key="n">
              <div class="iosCard" :class="['ma-4']">
                <img
                  :src="
                    require('@/assets/images/media-mentions/img' + n + '.png')
                  "
                  alt="..."
                  class="mediaImg"
                />
              </div>
            </v-slide-group-item>
          </v-slide-group>
        </div>
      </v-container>
    </div>

    <!-- <div class="becomeFreedPP">
      <div class="overlayImg-1">
        <img src="@/assets/images/freed-small-logo.svg" />
      </div>
      <div class="overlayImg-2">
        <img src="@/assets/images/freed-small-logo.svg" />
      </div>
      <div class="incomeHeading">
        Join FREED Partner Program! Help People & Make Money
      </div>
      <div class="PPSubHeading">
        Become a FREED Authorised Partner today<br />
        Help More, Earn More.
      </div>
      <button
        type="button"
        class="btn btn-secondary calculator-btn"
        @click="scrollToTop"
      >
        Become a FREED Partner
      </button>
      <div class="PPSubHeading font-weight-bold mt-4">
        For Queries- Call/WhatsApp us at +91-9971800833
      </div>
    </div> -->

    <div class="greyIncomeSection faqSection">
      <template>
        <div class="faqHeading">Frequently Asked Questions</div>
        <v-container>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header
                ><div class="expansion-heading">
                  How does the FREED Partner Program work?
                </div>
                <template v-slot:actions="{ open }">
                  <img
                    :src="
                      open
                        ? require('@/assets/images/faq/minusSignFaq.svg')
                        : require('@/assets/images/faq/plusSignFaq.svg')
                    "
                    alt="..."
                    class="faq-icon"
                  />
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                You identify people who are burdened with personal loan and
                credit card debt and are looking to get debt free. Once you have
                spoken with them about FREED's program and ascertained their
                intent to sign up, you share the unique referral link with them.
                FREED's Debt Relief Platform does the rest.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header
                ><div class="expansion-heading">
                  How do I qualify for this program?
                </div>
                <template v-slot:actions="{ open }">
                  <img
                    :src="
                      open
                        ? require('@/assets/images/faq/minusSignFaq.svg')
                        : require('@/assets/images/faq/plusSignFaq.svg')
                    "
                    alt="..."
                    class="faq-icon"
                  /> </template
              ></v-expansion-panel-header>
              <v-expansion-panel-content>
                If you are 18 years or older and want to bring relief and smiles
                to debt-burdened consumers of India, you are eligible to become
                a FREED Authorised Partner. There are no pre-qualifying criteria
                or a waiting period.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header
                ><div class="expansion-heading">
                  How do I earn in this program?
                </div>
                <template v-slot:actions="{ open }">
                  <img
                    :src="
                      open
                        ? require('@/assets/images/faq/minusSignFaq.svg')
                        : require('@/assets/images/faq/plusSignFaq.svg')
                    "
                    alt="..."
                    class="faq-icon"
                  /> </template
              ></v-expansion-panel-header>
              <v-expansion-panel-content>
                As a FREED Authorised Partner, you get a unique referral link to
                share with people who need help with resolving their credit card
                and personal loan debt. When they sign up and make their first
                payment, you start earning money. You get paid every time your
                referred client pays.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header
                ><div class="expansion-heading">
                  How do I sign up for the program?
                </div>
                <template v-slot:actions="{ open }">
                  <img
                    :src="
                      open
                        ? require('@/assets/images/faq/minusSignFaq.svg')
                        : require('@/assets/images/faq/plusSignFaq.svg')
                    "
                    alt="..."
                    class="faq-icon"
                  /> </template
              ></v-expansion-panel-header>
              <v-expansion-panel-content>
                It's very simple. Just
                <a @click="scrollToTop">click here</a> and signup. Once logged
                in, request your onboarding call to become a FREED Authorised
                Partner.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header
                ><div class="expansion-heading">
                  How and when do I receive my payout?
                </div>
                <template v-slot:actions="{ open }">
                  <img
                    :src="
                      open
                        ? require('@/assets/images/faq/minusSignFaq.svg')
                        : require('@/assets/images/faq/plusSignFaq.svg')
                    "
                    alt="..."
                    class="faq-icon"
                  /> </template
              ></v-expansion-panel-header>
              <v-expansion-panel-content>
                You will receive your payouts every week. You can also access
                your total earnings & performance metrics from the Partner
                Dashboard.
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header
                ><div class="expansion-heading">
                  How much do I have to pay to join the program?
                </div>
                <template v-slot:actions="{ open }">
                  <img
                    :src="
                      open
                        ? require('@/assets/images/faq/minusSignFaq.svg')
                        : require('@/assets/images/faq/plusSignFaq.svg')
                    "
                    alt="..."
                    class="faq-icon"
                  /> </template
              ></v-expansion-panel-header>
              <v-expansion-panel-content>
                ZERO! You don't pay any fees to become a FREED Authorised
                Partner.
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
      <VideoModal
        :dialogInput="dialogInput"
        :videoId="selectedVideoId"
        @close="closeAction(false)"
      />
    </div>
    <!-- <div :class="['learning-btn']">
      <img
        :src="require('@/assets/learn-btn-desktop.png')"
        width="150"
        class="learn-desktop"
        @click="closeAction(true)"
      />
      <img
        :src="require('@/assets/learn-btn-mobile.png')"
        width="50"
        class="learn-mobile"
        @click="closeAction(true)"
      />
    </div> -->
    <div :class="['becomeFreedBtn', addClass ? 'showBecomeFreedBtn' : '']">
      <v-btn color="primary" class="pa-7 partnerBtn" @click="scrollToTop"
        >Become a <br />FREED Partner
        <img src="@/assets/images/paper-plane-white.svg" alt="..." />
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
// import store, * as Store from '@/../src-gen/store';
import * as Data from "@/../src-gen/data";
// import * as ServerData from '@/../src-gen/server-data';
import * as Action from "@/../src-gen/action";
import SignupForm from "../components/sign-up-form.vue";
import VideoModal from "../components/video-modal.vue";
import { VSlideGroup, VSlideItem } from "vuetify/lib";

@Component({
  components: {
    "v-slide-group": VSlideGroup,
    "v-slide-group-item": VSlideItem,
    SignupForm,
    VideoModal,
  },
})
export default class Home extends Vue {
  carousel: number = 0;
  interval: number = 3000;
  confirmPassword: string = "";
  addClass = false;
  offsetHeight = 400;
  signUpInput: Data.Partner.SignUpInput = new Data.Partner.SignUpInput();

  get heroBannerImage() {
    if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
      return require("@/assets/images/heroBanner/mobileHeroBanner.svg");
    }
    return require("@/assets/images/heroBanner/heroBanner.svg");
  }
  emailRules = [
    (v: any) => !!v.trim() || "Email is required",
    (v: any) => v.indexOf(" ") === -1 || "Provide a valid Email",
    (v: any) => /.+@.+\..+/.test(v) || "Provide a valid Email",
  ];
  firstNameRules = [(v: any) => !!v.trim() || "Name is required"];
  mobileRules = [
    (v: any) => !!v || "Mobile Number is required",
    (v: any) => {
      const value = v?.replace(" ", "");
      return (!!value && value.length === 10) || "Please Enter valid  Number";
    },
  ];
  passwordRules = [(v: any) => !!v || !!v.trim() || "Password  is required"];
  confirmPasswordRules = [
    (v: any) => !!v || !!v.trim() || "Confirm Password  is required",
    (v: any) =>
      v === this.signUpInput.password || "Confirm Password  doesn't match",
  ];
  dialogInput: boolean = false;
  selectedVideoId: string = "";

  closeAction(close: boolean = false) {
    this.dialogInput = close;
    if (!close) {
      this.selectedVideoId = "";
    }
  }

  playVideo(videoId: string) {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank");
  }

  onSignUp() {
    const valid = (this.$refs.signUpRef as any).validate();
    if (valid) {
      const [firstName = "", lastName = ""] =
        this.signUpInput.firstName.split(" ");
      this.signUpInput.firstName = firstName;
      this.signUpInput.lastName = lastName;
      Action.Partner.SignUp.execute(this.signUpInput, (output) => {
        this.$router.push({ name: "Login.Login" });
      });
    }
  }
  get carouselHeight() {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return "1300";
      case "sm":
        return "1300";
      case "md":
        return "900 ";
      case "lg":
        return "900";
      case "xl":
        return "900";
    }
  }
  scrollToTop() {
    window.scrollTo(0, 0);
  }
  imageCaoursel = "@/assets/images/banner_image1.png";
  get carouselImages() {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return {
          1: require("@/assets/images/mobile/a.png"),
          2: require("@/assets/images/mobile/b.png"),
          3: require("@/assets/images/mobile/c.png"),
        };
      case "sm":
        return {
          1: require("@/assets/images/mobile/a.png"),
          2: require("@/assets/images/mobile/b.png"),
          3: require("@/assets/images/mobile/c.png"),
        };
      case "md":
        return {
          1: require("@/assets/images/banner_image1.png"),
          2: require("@/assets/images/banner_image2.png"),
          3: require("@/assets/images/banner_image3.png"),
        };
      case "lg":
        return {
          1: require("@/assets/images/banner_image1.png"),
          2: require("@/assets/images/banner_image2.png"),
          3: require("@/assets/images/banner_image3.png"),
        };
      case "xl":
        return {
          1: require("@/assets/images/banner_image1.png"),
          2: require("@/assets/images/banner_image2.png"),
          3: require("@/assets/images/banner_image3.png"),
        };
    }
  }

  created() {
    document.addEventListener("scroll", this.scroll);
  }

  mounted() {
    scroll();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  scroll() {
    if (window.scrollY >= this.offsetHeight) {
      this.addClass = true;
    } else {
      this.addClass = false;
    }
  }
}
</script>

<style lang="scss">
.Home {
}
.formFooter {
  padding-top: 15px;
  text-align: center;
}
.formFooter a {
  color: #f16c23 !important;
  font-weight: bold;
}
.container {
  padding: 15px;
}
.btn.btn-secondary {
  background-color: #f16c23;
  border-color: #f16c23;
  font-size: 15px;
  font-weight: normal;
  box-shadow: none !important;
  min-width: 150px;
  padding: 8px 15px;
  display: flex;
  margin: 0 auto;
  color: #fff;
  border-radius: 4px;
  font-weight: bold;
  min-height: 50px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.calculator-btn img {
  width: 24px !important;
  height: 24px !important;
}
.calculator-btn:disabled {
  opacity: 0.5;
}
.containerCarousel {
  position: absolute;
  top: 0;
  z-index: 999;
  left: 0;
  right: 0;
}
.logo {
  position: absolute;
  z-index: 9;
  padding: 15px 10px;
}

.logo img {
  height: 60px;
}

@media screen and (max-width: 960px) {
  .logo {
    position: relative;
    z-index: 9;
    padding: 15px 10px;
    text-align: left;
  }

  .logo img {
    height: 50px;
  }
}
.partnerForm {
  position: relative;
  top: 100px;
  overflow-x: hidden;
}
.heroSignupWrapper {
  width: 100%;
  background-color: #f5f5f5;
}

.heroSignupSection {
  display: flex;
  position: relative;
  max-height: 860px;
  width: 100%;
  height: 860px;
  overflow: hidden;
}

.heroBannerContainer {
  position: relative;
  width: 100%;
  height: 100%;
}

.heroBannerImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.heroBannerOverlay {
  position: absolute;
  top: 0;
  left: 0;
  padding: 90px 80px;
  z-index: 2;
}

.bannerTitle {
  font-size: 46px;
  color: #fff;
  margin-bottom: 10px;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.bannerSubTitle {
  font-size: 48px;
  color: #fff;
  margin-bottom: 10px;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}
.partnerInputForm {
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  width: 450px;
}
.partnerInputForm {
  text-align: center;
}
.formTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
}
.icon-container {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
  animation: iconMove 3s infinite;
}
.incomeSection {
  padding-top: 60px;
}
.incomeHeading {
  font-size: 42px;
  color: #02416e;
  text-align: center;
  padding-bottom: 10px;
  padding-top: 50px;
  font-weight: bold;
}

.incomeSubHeading {
  font-size: 16px;
  color: #5d5d5d;
  text-align: center;
  padding-bottom: 10px;
}
.incomeCardContaner {
  padding: 45px 0;
}
.incomeCard {
  position: relative;
  border: 1px solid #f16c23;
  border-radius: 12px;
  padding: 10px;
}

.incomeCardInner {
  border: 4px solid #f16c23;
  border-radius: 12px;
  padding: 15px;
}

.incomeStep {
  background-color: #f16c23;
  color: #fff;
  font-size: 16px;
  border-radius: 20px;
  text-align: center;
  padding: 10px;
  position: absolute;
  top: -15px;
  left: 0;
  right: 0;
  width: 200px;
  margin: 0 auto;
}
.incomeCard.primaryBorder,
.incomeCardInner.primaryBorder {
  border-color: #004479 !important;
}
.incomeCard.primaryBorder .incomeStep {
  background-color: #004479;
}
.bodyContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 20px;
}
.bdHeading {
  font-size: 20px;
  font-weight: bold;
  color: #f36f21;
}
.bdDiscretion {
  color: #004479;
  font-weight: bold;
}
.incomeCardContaner {
  padding: 60px 0;
}

.incomeSection {
  padding-top: 60px;
}

.greyIncomeSection {
  background-color: #f3f9fb;
  padding: 40px 0px 10px 0px;
}

.leftIncomeList ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.leftIncomeList ul li {
  margin-bottom: 24px;
}
.leftIncomeList ul li:last-child {
  margin-bottom: 0;
}
.INCHeading {
  font-size: 20px;
  color: var(--text-primary-color);
  margin-bottom: 5px;
  display: flex;
  gap: 10px;
  align-items: center;
  font-weight: bold;
  color: #02416e;
}
.orange-plane-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}
.greyIncomeSectionSub,
.normalIncomeSection {
  position: relative;
  padding: 0px 0px 10px 0px;
}
.PPcontentImg img {
  width: 100%;
}
.joinNowSection {
  text-align: center;
  // padding-top: 15px;
}
.joinNowSection .btn {
  min-width: 125px;
  background-color: #02416e !important;
  border-color: #02416e !important;
}

.PPAboutSection {
  background-color: #fef4ef;
  padding: 60px 0;
}
.setpSectionBG {
  background-color: #fef4ef;
}
.videoSectionBG {
  background-color: #fff;
}

.PPSubHeading {
  font-size: 16px;
  text-align: center;
  margin-bottom: 30px;
  color: #5d5d5d;
}

.becomeFreedPP {
  overflow: hidden;
  position: relative;
  padding: 60px 0;
  text-align: center;
}
.overlayImg-1 {
  width: 200px;
  position: absolute;
  left: -50px;
  top: -31px;
  opacity: 0.1;
}
.overlayImg-2 {
  width: 200px;
  position: absolute;
  right: -50px;
  bottom: -31px;
  opacity: 0.1;
}
.incomeContentCard {
  display: flex;
  align-items: center;
  justify-content: left;
  padding-bottom: 30px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 30px;
}
.incomeContentCard p {
  font-size: 20px;
  margin: 0;
}
.incomeContentCard img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}
.borderRight {
  position: absolute;
  border: 0.5px solid #ccc;
  height: 100%;
  right: 50%;
}
.whyJoinContainer {
  width: 880px;
  max-width: 100%;
  height: 500px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.whyJoinGrid {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
  width: 100%;
  height: 100%;
}
.whyJoinCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  padding: 30px 15px;
  height: 100%;
}
.whyJoinIcon {
  width: 40px;
  height: 40px;
  margin-bottom: 20px;
  object-fit: contain;
}
.whyJoinText {
  font-size: 24px;
  font-weight: bold;
  color: #02416e;
  margin: 0;
  line-height: 1.4;
}
.expansion-heading {
  font-size: 16px;
  font-weight: bold;
}
.faqHeading {
  font-size: 46px;
  color: #02416e;
  text-align: center;
  padding-bottom: 10px;
  font-weight: bold;
}
.faqSection {
  background-color: #ffffff !important;
}
.faq-icon {
  width: 24px;
  height: 24px;
}
.faqSection .v-expansion-panels .v-expansion-panel {
  border: 1px solid #f1f1f1 !important;
  border-radius: 8px !important;
  margin-bottom: 16px !important;
  overflow: hidden;
  box-shadow: none !important;
}
.faqSection .v-expansion-panels .v-expansion-panel:last-child {
  margin-bottom: 0 !important;
}
.faqSection .v-expansion-panel--active {
  background-color: #eef9fe !important;
}
.faqSection .v-expansion-panel-content__wrap {
  background-color: #eef9fe !important;
  padding: 16px !important;
}
.faqSection .v-expansion-panel-content {
  background-color: #eef9fe !important;
}
.faqSection .v-expansion-panel-header {
  border-radius: 8px 8px 0 0;
  padding: 16px !important;
}
.faqSection .v-expansion-panel--active .v-expansion-panel-header {
  border-radius: 8px 8px 0 0;
  background-color: #eef9fe !important;
}
.faqSection .v-expansion-panel--active .v-expansion-panel-content {
  border-radius: 0 0 8px 8px;
}

.leftIncomeList ul > li:last-child .incomeContentCard {
  border-bottom: 0;
}
.becomeFreedBtn {
  position: fixed;
  bottom: 80px;
  right: 0;
  z-index: 9;
  display: none;
}
.learning-btn {
  position: fixed;
  top: 50px;
  right: 0;
  z-index: 189;
}
.learning-btn img {
  cursor: pointer;
}
.showBecomeFreedBtn {
  display: block;
}
.partnerBtn {
  border-radius: 12px !important;
  font-weight: bold;
}
.partnerBtn img {
  height: 24px;
  margin-left: 15px;
}
.PPSubHeading.ppBoldSub {
  color: #5d5d5d;
}

.iosCard {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  height: 135px;
  justify-content: center;
  align-items: center;
  display: flex;
}
.inPressSection {
  padding-top: 60px;
}
.videoCard {
  display: table;
  padding: 0 30px;
  min-width: 300px;
}
.videoCard iframe {
  width: 300px;
}

.videoCard img {
  width: 285px;
  height: 200px;
  border-radius: 8px;
}
.videoThumbnail {
  position: relative;
  cursor: pointer;
  width: 300px;
  height: 215px;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
}
.videoBanner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
.playButton {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  transition: transform 0.2s;
}
.videoThumbnail:hover .playButton {
  transform: translate(-50%, -50%) scale(1.1);
}
.videoSection {
  text-align: center;
  margin-top: 25px;
}
.mediaImg {
  width: 100%;
  height: 110px;
}
.v-application .teal--text {
  color: #004479 !important;
}
.partnerInputForm-mobile {
  width: 450px;
}
.partnerInputForm .v-text-field--outlined fieldset,
.partnerInputForm-mobile .v-text-field--outlined fieldset {
  border-radius: 40px;
  background: #eef2fb;
  border: 0;
}
.partnerInputForm .v-text-field--outlined.v-input--dense .v-label,
.partnerInputForm-mobile .v-text-field--outlined.v-input--dense .v-label,
.partnerInputForm-mobile .v-text-field input,
.partnerInputForm .v-text-field input {
  padding-left: 15px;
}
.incSUbcontent {
  padding-left: 46px;
  font-size: 16px;
  color: #5d5d5d;
  margin-top: 5px;
  line-height: 1.5;
}

.videoTitle {
  font-size: 24px;
  font-weight: bold;
  color: #02416e;
  margin-top: 25px;
}
.theme--light.v-expansion-panels .v-expansion-panel {
  background: inherit;
}
.faqSection .theme--light.v-expansion-panels .v-expansion-panel {
  border: 1px solid #f1f1f1 !important;
  border-radius: 8px !important;
  margin-bottom: 16px !important;
  overflow: hidden;
  box-shadow: none !important;
}
.faqSection .theme--light.v-expansion-panels .v-expansion-panel--active {
  background-color: #eef9fe !important;
}
.faqSection
  .theme--light.v-expansion-panels
  .v-expansion-panel--active
  .v-expansion-panel-header {
  background-color: #eef9fe !important;
}
.faqSection .theme--light.v-expansion-panels .v-expansion-panel-content__wrap {
  background-color: #eef9fe !important;
  padding: 16px !important;
}
.faqSection .theme--light.v-expansion-panels .v-expansion-panel-content {
  background-color: #eef9fe !important;
}

.overlyText-carousel {
  position: absolute;
  bottom: 120px;
  right: 60px;
  font-size: 70px;
  font-weight: bold;
  color: #fff;
  // font-family: "Dancing Font";
  transform: rotate(-15deg);
  letter-spacing: 5px;
  z-index: 199;
  font-family: "Alex Brush", cursive;
}
.video-carousel .v-slide-group__content {
  justify-content: center;
}
.video-carousel .v-slide-group__prev,
.video-carousel .v-slide-group__next {
  display: none !important;
}
.v-expansion-panel::before {
  box-shadow: none;
}
.faqSection .v-expansion-panel::before {
  display: none;
}
.v-expansion-panel-header {
  font-weight: bold;
}
@media screen and (max-width: 960px) {
  .logo {
    position: relative;
    z-index: 9;
    padding: 15px 10px;
    text-align: left;
  }

  .logo img {
    height: 50px;
  }

  .heroSignupWrapper {
    padding: 0;
    background-color: #ffffff;
  }

  .heroSignupSection {
    flex-direction: column;
    max-height: none;
    height: auto;
    position: relative;
    align-items: center;
    background-color: #ffffff;
  }

  .heroBannerContainer {
    width: 330px;
    height: 165px;
    position: relative;
    margin: 0 auto;
  }

  .heroBannerImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  .heroBannerOverlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 15px 20px;
    background: transparent;
    z-index: 2;
    text-align: left;
  }

  .bannerTitle {
    font-size: 18px;
    color: #fff;
    margin-bottom: 4px;
    font-weight: bold;
    line-height: 1.2;
    text-align: left;
  }

  .bannerSubTitle {
    font-size: 20px;
    color: #fff;
    margin-bottom: 0;
    font-weight: bold;
    line-height: 1.2;
    text-align: left;
  }

  .partnerFormContainer {
    position: relative;
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 20px;
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .video-carousel {
    display: block;
  }
  .video-carousel .v-slide-group__content {
    justify-content: flex-start;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }
  .video-carousel .v-slide-group-item {
    scroll-snap-align: start;
    flex: 0 0 auto;
  }
  .videoCard {
    display: table;
    padding: 0 15px;
    min-width: 280px;
  }
  .video-carousel .v-slide-group__content {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .video-carousel .v-slide-group__content::-webkit-scrollbar {
    display: none;
  }
  .video-carousel .v-slide-group-item {
    scroll-snap-align: start;
    flex: 0 0 auto;
  }
  .incomeSection,
  .incomeCardContaner,
  .greyIncomeSection {
    padding: 30px 0;
  }
  .incomeCardContaner {
    padding-bottom: 0;
  }
  .incomeHeading {
    font-size: 32px;
    color: #02416e;
    text-align: center;
    padding-bottom: 5px;
    font-weight: bold;
  }
  .incomeSubHeading {
    font-size: 16px;
    text-align: center;
  }
  .overlayImg-1 {
    width: 200px;
    position: absolute;
    left: -50px;
    top: -31px;
    opacity: 0.1;
  }
  .overlayImg-2 {
    width: 200px;
    position: absolute;
    right: -50px;
    bottom: -31px;
    opacity: 0.1;
  }
  .becomeFreedPP {
    overflow: hidden;
    position: relative;
    padding: 30px 15px;
    text-align: center;
  }
  .PPSubHeading {
    font-size: 16px;
    text-align: center;
    margin-bottom: 30px;
    color: #5d5d5d;
  }

  .lastCard h3 {
    font-size: 16px;
  }
  .PPcontentImg {
    position: absolute;
    top: 18px;
    left: 0;
    right: 0;
    z-index: 9;
  }
  .leftIncomeList {
    margin-top: 60%;
  }
  .INCHeading {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 5px !important;
  }
  .greyIncomeSectionSub {
    padding-bottom: 0;
    padding-left: 15px;
    padding-right: 15px;
  }
  .greyIncomeSection {
    padding-bottom: 0;
  }
  .normalIncomeSection {
    padding: 30px 0;
  }
  .leftIncomeList.mg0 {
    margin: 0;
  }
  .greyIncomeSectionSub .col-md-6 {
    padding-bottom: 0;
    padding-top: 0;
  }
  .leftIncomeList ul > li:last-child .incomeContentCard {
    border-bottom: 1px solid #ccc;
  }
  .leftIncomeList.borderRight {
    border: 0;
  }
  .PPAboutSection {
    padding: 30px 0;
  }
  .PPAboutSection .v-row {
    display: flex;
    flex-wrap: wrap;
  }
  .PPAboutSection .v-col:nth-child(4) {
    margin-left: 20%;
  }
  .PPAboutSection .iosCard {
    width: 90px !important;
    height: 90px !important;
    padding: 10px;
  }

  .PPAboutSection .iosCard img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .inPressSection {
    padding-top: 30px;
  }
  .PPAboutSection .PPSubHeading.ppBoldSub {
    padding: 0 30px;
  }
  .inPressSection .pa-4 {
    padding: 0 !important;
  }
  .inPressSection .iosCard {
    width: 90px;
    height: 80px;
    padding: 10px;
    margin: 8px;
    min-width: 90px;
    flex-shrink: 0;
  }
  .inPressSection .mediaImg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  // .becomeFreedBtn {
  //   position: inherit;
  // }
  .becomeFreedBtn {
    width: 100%;
    bottom: 0;
  }
  .becomeFreedBtn .partnerBtn {
    width: 100%;
    border-radius: 0 !important;
  }
  .overlayImg-1,
  .overlayImg-2 {
    width: 135px;
  }
  .borderRight {
    display: none;
  }
  .whyJoinContainer {
    width: 100%;
    height: auto;
    min-height: auto;
    padding: 20px 0;
  }
  .whyJoinGrid {
    margin: 0;
  }
  .whyJoinCard {
    padding: 20px 15px;
    margin-bottom: 20px;
    align-items: center;
    text-align: center;
  }
  .whyJoinIcon {
    width: 40px;
    height: 40px;
    margin-bottom: 15px;
  }
  .whyJoinText {
    font-size: 16px;
    text-align: center;
  }
  .videoCard iframe {
    width: 100%;
    border-radius: 10px;
  }
  .videoThumbnail {
    width: 100%;
    max-width: 100%;
  }
  .videoBanner {
    width: 100%;
    height: auto;
  }
  .greyIncomeSection.faqSection {
    padding-bottom: 60px;
    background-color: #ffffff !important;
  }
  .faqHeading {
    font-size: 22px;
  }
}
.learn-mobile {
  display: none;
}
.learn-desktop {
  display: block;
}
@media screen and (max-width: 600px) {
  .learn-mobile {
    display: block;
  }
  .learn-desktop {
    display: none;
  }
  .lastCard {
    font-size: 16px;
  }
}
::v-deep .v-dialog__content .v-dialog {
  box-shadow: none !important;
}
.moreIncome_sec {
  margin: auto;
}
.lastCard {
  justify-content: center !important;
  font-weight: bold;
  font-size: 22px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  // padding-bottom: 30px;
  color: #02416e;
  text-align: center;
}
.lastCard h3 {
  color: #02416e;
  margin: 0;
}
</style>
